import React, { useEffect, useState } from 'react';
import styles from './actionOptionsPopover.module.sass';
import getSkin from './skin.js';
import { css } from 'aphrodite/no-important';
import applyWrappers from 'wrappers/ComponentWrapper';
import Close from 'svgComponents/close';
import ActionOption from 'components/sprint/execution/actionOption';
import FilledButton from 'commonComponents/buttons/filledButton';
import { actionIds, actionOptionIds } from 'config/actions';
import { getUserMetricsForMetricsKey } from 'util/utilFunctions';
import skins from 'defaults/skins'

const ActionOptionsPopover = (props) => {

	let defaultActionOptionId = -1;
	if(props.tutorial.isRunning && props.tutorial.type === "sprintExecutionScreen"){
		defaultActionOptionId = 11;
	}
	else defaultActionOptionId = props.selectedActionOptions[0] ? props.selectedActionOptions[0].id : -1;
	const [selectedActionOptionId, setSelectedActionOptionId] = useState(defaultActionOptionId);

	const { totalDaysInSprint, currentSprintDay } = props.userState;
	const daysRemainingInSprint = totalDaysInSprint - currentSprintDay + 1;

	const selectedActionOption = props.selectedActionOptions.filter(
		actionOptions => actionOptions.id === selectedActionOptionId
	)[0];

	const budgetUserMetrics = getUserMetricsForMetricsKey(
		props.metrics.metricsList,
		props.userMetrics.userMetricsList,
		'BUDGET'
	);

	const currentBudget = budgetUserMetrics && budgetUserMetrics.value || 0;

	const myStyles = getSkin(props.skinGuide);

	let popoverPositionStyle = {
		top: '25vh',
		right: '23.171vw',
		position: 'fixed'
	}
	let popoverContainerStyle = 'popover-container';

	if (props.isActionsFromStoryPopup) {
		popoverPositionStyle = {
			top: '36.5vh',
			right: '35vw',
			position: 'fixed'
		};
		popoverContainerStyle = 'popover-container-story'
	}

	if (props.isActionsFromEventPopup) {
		popoverPositionStyle = {
			bottom: '20vh',
			right: '26vw',
			position: 'fixed'
		};
		popoverContainerStyle = 'popover-container-event'
	}

	// let popoverArrowStyle = {
	// 	top: '10px',
	// 	left: '-10px'
	// }

	const isActionPossibleBasedOnBudget = () => {
		const actionOptionBudget = selectedActionOption.cost;

		if (actionOptionBudget <= currentBudget) {
			return true;
		}
		return false;
	}

	const isActionPossibleBasedOnGameLimit = () => {
		let gameLimit = selectedActionOption.gameLimit;
		if (gameLimit === null) {
			gameLimit = props.action.gameLimit;
		}

		if (gameLimit === null) {
			return true;
		}

		const selectedUserActionOptions = props.userActions.userActionsList.filter(
			userAction => userAction.actionOptionId === selectedActionOptionId
		);

		if (selectedUserActionOptions.length < gameLimit) {
			return true;
		}

		return false;
	}

	const isActionPossibleBasedOnSprintLimit = () => {
		let sprintLimit = selectedActionOption.sprintLimit;
		if (sprintLimit == null) {
			sprintLimit = props.action.sprintLimit;
		}

		if (sprintLimit == null) {
			return true;
		}

		const selectedUserActionOptions = props.userActions.userActionsList.filter(
			userAction => (
				userAction.actionOptionId === selectedActionOptionId
				&& userAction.sprintNumber === props.userState.currentSprintNumber
			)
		);

		if (selectedUserActionOptions.length < sprintLimit) {
			return true;
		}

		return false;
	}

	const isActionPossibleBasedOnDays = () => {
		if (props.selectedActionOptions.length === 0) {
			return false;
		}

		if (daysRemainingInSprint >= selectedActionOption.effort) {
			// if (selectedActionOptionId === actionOptionIds.REPLAN_SPRINT) {
			// 	if (daysRemainingInSprint > 2 && (props.userState.totalDays - props.userState.currentDay > 2)) {
			// 		return true;
			// 	}
			// 	return false;
			// }
			return true;
		}

		return false;
	}

	const isActionOptionsAvailable = () => {
		if (props.selectedActionOptions.length === 0) {
			return false;
		}

		return true;
	}

	const getTakeActionButtonStyle = () => {
		if (
			!isActionOptionsAvailable()
			|| !isActionPossibleBasedOnDays()
			|| !isActionPossibleBasedOnBudget()
			|| !isActionPossibleBasedOnGameLimit()
			|| !isActionPossibleBasedOnSprintLimit()
		) {
			return {
				pointerEvents: 'none',
				opacity: 0.5
			};
		}
		return {
			pointerEvents: 'all',
			opacity: 1
		};
	}
	const submitActionAndClosePopover = () => {
		let actionOptionIdForFetchCall = selectedActionOptionId;
		let actionPayload = {
			selectedActionOption: selectedActionOption
		};
		if(props.isActionsFromStoryPopup){
			actionPayload = {
				...actionPayload,
				blockerId: props.blockerId
			}
		}
		if(props.isActionsFromEventPopup){
			props.updateEventsToBeShownCount(props.updatedEventsToBeShownCount);
			actionPayload = {
				...actionPayload,
				eventId: props.eventId
			}
		}
		// if (props.action.id === actionIds.UPDATE_PRD) {
		// 	actionOptionIdForFetchCall = actionOptionIds.UPDATE_PRD;
		// 	actionPayload = {
		// 		prdId: selectedActionOptionId
		// 	};
		// }

		// if (props.action.id === actionIds.REPLAN_SPRINT) {
		// 	actionOptionIdForFetchCall = actionOptionIds.REPLAN_SPRINT;
		// 	actionPayload = {
		// 		sprintId: props.userState.currentSprintNumber
		// 	};
		// 	props.setUiState({
		// 		showActionOptionPopover: false,
		// 		selectedActionId: null,
		// 		showOverlay: true,
		// 		overlayComponentType: 'CENTER',
		// 		highlightDesktopHeader: true,
		// 		highlightMetricsHeader: false,
		// 		overlayComponent: 'REPLAN_SPRINT_CONFIRMATION'
		// 	});
		// 	props.setIsActionOnHover(false);
		// 	return 1;
		// }
		if(props.tutorial.isRunning){
			props.updateStepNumber(props.tutorial.stepIndex + 1);
			props.pauseTutorial();
		}
		props.submitAction(actionOptionIdForFetchCall, actionPayload, props.isActionsFromStoryPopup, props.isActionsFromEventPopup);
		props.setUiState({
			showActionOptionPopover: false,
			selectedActionId: null
		});
		props.setIsActionOnHover(false);
	}

	const renderOptions = () => {
		if (props.selectedActionOptions.length === 0) {
			return null;
		}
		return (
			<ActionOption
				action={props.action}
				selectedActionOptions={props.selectedActionOptions}
				selectedActionOptionId={selectedActionOptionId}
				setSelectedActionOptionId={setSelectedActionOptionId}
			/>
		);
	}

	const getErrorMessage = () => {
		if (!isActionOptionsAvailable()) {
			return props.getLabel('label_error_message_no_options');
		}

		if (!isActionPossibleBasedOnDays()) {
			return props.getLabel('label_error_message_insufficient_days').replace(
				'%{REMAINING_DAYS}',
				daysRemainingInSprint
			);
		}

		if (!isActionPossibleBasedOnBudget()) {
			return props.getLabel('label_error_message_insufficient_budget');
		}

		if (!isActionPossibleBasedOnGameLimit()) {
			return props.getLabel('label_error_message_game_limit');
		}

		if (!isActionPossibleBasedOnSprintLimit()) {
			return props.getLabel('label_error_message_sprint_limit');
		}

		return '';
	}

	const renderErrorMessage = () => {
		if (
			!isActionOptionsAvailable()
			|| !isActionPossibleBasedOnDays()
			|| !isActionPossibleBasedOnBudget()
			|| !isActionPossibleBasedOnGameLimit()
			|| !isActionPossibleBasedOnSprintLimit()
		) {
			return (
				<div
					styleName="error-message"
					className={css(myStyles.errorMessage)}
				>
					{getErrorMessage()}
				</div>
			);
		}

		return null;
	}

	return (
		<div>
			<div
				className={css(myStyles.container)}
				styleName={popoverContainerStyle}
				style={popoverPositionStyle}
			>
				<div styleName="popover-container-child" id="popover-container"></div>
				<div className={css(myStyles.header)} styleName="popover-header">
					<div styleName="title-and-description">
						<div className={css(myStyles.title)} styleName="title"
						style={props.isActionsFromStoryPopup ? {fontFamily: skins.fontFamily.bodyFamily} : null}>{props.getLabel(props.action.name)}</div>
						<div className={css(myStyles.description)}>{props.getLabel(props.action.description)}</div>
					</div>
					{/* <div styleName="close-container">
						<div
							styleName="close-svg"
							onClick={() => {
								props.setUiState({
									showActionOptionPopover: false,
									selectedActionId: null
								});
								props.setIsActionOnHover(false)
							}}
						>
							<Close />
						</div>
					</div> */}
				</div>
				{ !props.isActionsFromEventPopup && !props.isActionsFromStoryPopup ?
				<div>	
					<div className={css(myStyles.chooseOptions)} styleName="choose-options">
						{props.getLabel('label_action_options_choose_heading')}
					</div>
					<div styleName="options-container">
						{renderOptions()}
					</div>
					{renderErrorMessage()}
				</div>
				: null
				}
				<div
					styleName="button-container"
					style={getTakeActionButtonStyle()}
				>
					<FilledButton
						textLabel={props.getLabel('label_take_action')}
						showButtonShadow={false}
						clickFunction={submitActionAndClosePopover}
					/>
				</div>
			</div>
			{/* <div
				className={css(myStyles.popoverArrow)}
				styleName="popover-arrow"
				style={popoverArrowStyle}
			/> */}
		</div>
	);
}

export default applyWrappers(ActionOptionsPopover, styles);